import { render, staticRenderFns } from "./generale.vue?vue&type=template&id=4b21fbdb&"
import script from "./generale.vue?vue&type=script&lang=js&"
export * from "./generale.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports